// Pure rules for the public lead forms (ContactNew, AutomacaoCTAForm) and the
// Anti-spam admin tab: honeypot field name, fill-time measurement (time-trap),
// whether the Turnstile challenge lets the form submit, and pt-BR copy for
// submit-lead's anti-bot error codes and quarantine reasons.

/** Hidden input bots fill and humans never see. submit-lead drops the lead when it is non-empty. */
export const HONEYPOT_FIELD = "website";

/** Props that keep password managers / autofill out of the honeypot (fewer false positives). */
export const HONEYPOT_INPUT_PROPS = {
  name: HONEYPOT_FIELD,
  type: "text",
  tabIndex: -1,
  autoComplete: "off",
  "data-1p-ignore": "true",
  "data-lpignore": "true",
  "data-form-type": "other",
} as const;

/** Milliseconds the form was on screen before submit (time-trap input for submit-lead). */
export function formElapsedMs(startedAt: number, now: number): number {
  return Math.max(0, Math.round(now - startedAt));
}

export type LeadRejectionReason = "honeypot" | "too_fast";

export const REJECTION_REASON_LABEL: Record<LeadRejectionReason, string> = {
  honeypot: "Campo-armadilha preenchido",
  too_fast: "Enviado rápido demais",
};

/** Label for a quarantine reason; unknown values are shown as-is. */
export function rejectionReasonLabel(reason: string): string {
  return REJECTION_REASON_LABEL[reason as LeadRejectionReason] ?? reason;
}

export type CaptchaState = "ready" | "pending" | "failed";

/** "ready" only with a token; "failed" when the widget could not load or errored. */
export function captchaState({
  token,
  failed,
}: {
  token: string | null;
  failed: boolean;
}): CaptchaState {
  if (token) return "ready";
  return failed ? "failed" : "pending";
}

const LEAD_ERROR_COPY: Record<string, string> = {
  captcha_required: "Confirme a verificação de segurança antes de enviar.",
  captcha_invalid:
    "Não conseguimos confirmar que você não é robô. Refaça a verificação e envie de novo.",
  captcha_unavailable:
    "A verificação de segurança está indisponível agora. Tente em instantes ou chame no WhatsApp.",
  rate_limited: "Muitas tentativas seguidas. Aguarde alguns minutos ou chame no WhatsApp.",
};

/** Toast copy for a submit-lead error code; unknown codes get the form's own fallback. */
export function leadSubmitErrorMessage(code: string | null | undefined, fallback: string): string {
  return (code && LEAD_ERROR_COPY[code]) || fallback;
}
